import { ProjectConfigSwitch } from "../components/ProjectConfigSwitch";
import { SldEditorForm } from "../components/SldEditorForm";

export const SLD_PAGE_INTRO =
  "Enter the project revision's buses, sources, transformers, feeders and loads. The " +
  "diagram is drawn from these lists and checked for structural errors; it is a design " +
  "document of the revision, not a calculation.";
export const SLD_PAGE_NOTE =
  "Symbols are generic shapes, not IEC 60617 symbols (GAP-023). An issued revision's " +
  "diagram is read-only; open a new revision and copy the diagram to change it.";

// The single-line diagram page (SLD-a, Master Prompt A26 (i)): the second page of EOS-01,
// reached through the project configuration switch. Full width and no study layout: the
// editor form, with its validation panel and live preview, is the page. The diagram is a
// design document of the project revision, not a calculation, so there is no result column
// and no run. Without a project revision in the top bar the form says so itself.
export function SldPage() {
  return (
    <main data-sld-page>
      <ProjectConfigSwitch />
      <header>
        <p>EOS-01 · Project configuration</p>
        <h1>Single-line diagram</h1>
        <p>{SLD_PAGE_INTRO}</p>
      </header>
      <SldEditorForm />
      <p data-sld-page-note="true">{SLD_PAGE_NOTE}</p>
    </main>
  );
}

export default SldPage;
